export const LOCATIONS_DIALOG = 'LOCATIONS_DIALOG';
